'use strict';

var AuthError = require('./AuthError.js');

class AuthWindowBlockedError extends AuthError.AuthError {
    constructor(params) {
        const { message = 'Child window for authentication was blocked', phone } = params || {};
        super({ message, phone });
    }
}

exports.AuthWindowBlockedError = AuthWindowBlockedError;
//# sourceMappingURL=AuthWindowBlockedError.js.map
